export enum EditTypes {
  collectionName = 'collectionName',
  collectionCreate = 'collectionCreate'
}
